import { useState, useCallback } from 'react';
export function useCursorPagination() {
  const [currentPage, setCurrentPage] = useState(1);
  const [cursorHistory, setCursorHistory] = useState({});
  const currentCursor = cursorHistory[currentPage];
  const onPageChange = useCallback((newPage, nextCursor) => {
    if (newPage === currentPage) {
      return;
    }
    if (newPage === 1) {
      setCursorHistory({});
      setCurrentPage(1);
    } else if (newPage > currentPage && nextCursor) {
      setCursorHistory(prev => Object.assign({}, prev, {
        [newPage]: nextCursor
      }));
      setCurrentPage(newPage);
    } else {
      setCurrentPage(newPage);
    }
  }, [currentPage]);
  return {
    currentPage,
    currentCursor,
    onPageChange
  };
}
export function getPaginationInfo(currentPage, paging) {
  var _paging$next, _paging$next2;
  const hasMore = Boolean(paging === null || paging === void 0 || (_paging$next = paging.next) === null || _paging$next === void 0 ? void 0 : _paging$next.after);
  const pageCount = hasMore ? Infinity : currentPage;
  return {
    hasMore,
    pageCount,
    nextCursor: paging === null || paging === void 0 || (_paging$next2 = paging.next) === null || _paging$next2 === void 0 ? void 0 : _paging$next2.after
  };
}